<template>
    <div>
        <div v-if="!pending">
            <oem-download :oem="oemObj" :productLine="productLineObj" />
            <section>
                <div class="container">
                    <div class="row justify-between q-col-gutter-xl">
                        <div class="col-xs-12 col-sm-12 col-md-5">
                            <q-card class="full-width">
                                <q-card-section :class="{'q-pa-lg' : !screenSize.xs, 'q-pa-md q-pt-lg' : screenSize.xs}">
                                    <download-form :download="currentDownloadObj"
                                                   :oem="oemObj" />
                                </q-card-section>
                            </q-card>
                        </div>
                        <div class="col-xs-12 col-md-7">
                            <revision-notes :revision="revision" />
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <q-inner-loading :showing="pending">
            <div>
                <q-spinner color="primary"
                           :thickness="2"
                           size="3em" />
            </div>
        </q-inner-loading>
    </div>
</template>
<script>
    import oemDownload from '@/components/OEMDownload'
    import revisionNotes from '@/components/RevisionNotes'
    import downloadForm from '@/components/DownloadForm'
    import { mapState } from 'vuex'
    import { productLines } from '@/plugins/productLines'

    export default {
        name: 'file-download',
        props: {
            productLine: String,
            oem: String,
        },
        components: {
            oemDownload,
            revisionNotes,
            downloadForm
        },
        data() {
            return {
                currentDownloadObj: null,
                oemObj: null,
                productLines: Object.keys(productLines)?.map(key => {
                    return productLines[key];
                }),
                revision: null,
                oems: [],
            }
        },
        methods: {
            getOems() {
                this.oems = []
                this.$store.dispatch('getOEMs').then(() => {
                    this.oemObj = this.getOemsData?.find(o => o.id.toLowerCase() == this.oem.toLowerCase())
                    if (!this.oemObj) this.$router.push('/download/loopcad')
                    this.getDownloads()
                })

            },
            getDownloads() {
                if (this.oem) {
                    this.$store.dispatch('getLatestDownloads', this.oem).then(() => {
                        this.getCurrentDownload()
                        this.getRevision()
                    })
                }
            },
            getCurrentDownload() {
                if (this.getLatestDownloadsData && this.oem && this.productLine) {
                    this.currentDownloadObj = this.getLatestDownloadsData?.find(d => d.oemId.toLowerCase() == this.oem.toLowerCase() && d.productCategoryID == this.productLineObj.name)
                }
            },
            getRevision() {
                this.revision = null
                const payload = {
                    productCategoryId: this.currentDownloadObj.productCategoryID,
                    version: this.currentDownloadObj.versionText,
                }
                this.$store.dispatch('getRevision', payload).then(() => {
                    this.revision = this.getRevisionData
                })
            },
        },
        computed: {
            ...mapState([
                'getOemsPending',
                'getOemsData',
                'getLatestDownloadsPending',
                'getLatestDownloadsData',
                'getRevisionPending',
                'getRevisionData',
            ]),

            productLineObj() {
                if (this.productLines)
                    return this.productLines?.find(pl => pl.name.toLowerCase() == this.productLine.toLowerCase())
                return null
            },
            pending() {
                return this.getOemsPending || this.getLatestDownloadsPending || this.getRevisionPending
            },
            screenSize() {
                return this.$q.screen
            },
        },
        created() {
            if (!this.productLineObj) this.$router.push('/download/loopcad')
            this.getOems()
        },
        watch: {
            oem(newVal) {
                this.getOems()
            }
        }

    }
</script>
